import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from 'components/Navigation/Components/Button';
import {Edit2, Minus, Plus, Trash2, X} from 'react-feather';
import {path} from 'ramda';
import noPhoto from 'media/no-photo.jpeg';
import useCard from 'hooks/useCard';
import formatNumber from 'helpers/formatNumber';
import {bottomSheet} from 'react-simple-bottom-sheet';
import SetAmount from 'components/SetAmount';
import {useTranslate} from 'helpers/translate';
import Detail from 'components/Detail';
import numberFormat from "../../helpers/numberFormat";
import toNumber from "../../helpers/toNumber";

const Wrapper = styled('div')`
    height: 275px;
    background: white;
    padding: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    max-width: 186px;
    position: relative;
    border-radius: 10px;
    width: ${({width}) => width || 'max-content'};
    margin: auto;
`

const Image = styled('div')`
    width: 100%;
    height: 140px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 10px;

    background: #FFFFFF;
    border: 0.5px solid #E4E5EC;
    border-radius: 6px;

    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`

const Content = styled('div')`
    width: 100%;
    padding: 0 10px;
    margin-top: 10px;
`

const Price = styled('div')`
    display: flex;
    margin-top: 6px;
    align-items: center;

    & * {
        font-family: var(--medium);
    }

    & p {
        font-size: 15px;
        line-height: 14px;
        text-align: right;
        color: #252325;
    }
`

const Available = styled('div')`
    display: flex;
    margin-top: 6px;
    align-items: center;

    & * {
        font-family: var(--medium);
    }

    & p {
        font-size: 12px;
        line-height: 14px;
        text-align: right;
        color: #475061;
    }
`

const Name = styled('div')`
    margin-bottom: 5px;

    & * {
        font-family: var(--light);
    }

    & p {
        font-size: 14px;
        color: #252325;
        mix-blend-mode: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`

const Fixed = styled('div')`
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 5px;
    height: max-content;
    width: 100%;
`

const Calc = styled('div')`
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    background: #F2F2F2;
    border-radius: 8px;
    overflow: hidden;
`

const Label = styled('div')`
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;

    & input {
        max-width: 60px;
        border: none;
        outline: none;
        height: 45px;
        text-align: center;
    }

    & p {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 135%;
        text-align: center;
        color: #000000;
    }
`

const Header = styled('div')`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: -10px;

    .flex {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }

    & p {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 23px;
        letter-spacing: -0.5px;
        color: ${({link}) => link ? '#2934D0' : '#282828'};

    }
`

const EditIcon = styled('div')`
    width: 30px;
    height: 30px;
    background: #2934D0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: absolute;
    right: 10px;
    top: 10px;
`

const FullWidth = styled.div`
  width: 100%;
`

const Card = (props) => {
  const {width, data, isOrder, onDelete} = props;
  const {handleAdd, exist, amount, handleRemove, handleChange} = useCard(data);
  const {t} = useTranslate()

  // Data
  const image = path(['image', 'file'], data);
  const name = path(['name'], data);
  const cashPrice = path(['cashPrice'], data);
  const boxAmount = path(['boxAmount'], data)
  const boxName = path(['boxName'], data)
  const available = path(['available'], data);
  const measurement = path(['measurement', 'name'], data);
  const currency = path(['currency', 'sign'], data);

  const boxValue = Math.floor(amount / boxAmount);
  const amountValue = amount % boxAmount;

  const openDetail = () => {
    document.querySelector('body').classList.add('hidden')
    bottomSheet.close({id: 'set-amount'})
    bottomSheet.create({
      content: <Detail
        isOrder={isOrder}
        data={data}
      />,
      id: 'detail',
      dragHandle: ['mask'],
      header: detailHeaderContent
    })
  };

  const detailHeaderContent = (
    <Header>
      <div className={'flex'}>
        <p style={{width: '90%'}}>{name}</p>
        <X size={20} onClick={() => {
          bottomSheet.close({id: 'detail'})
          document.querySelector('body').classList.remove('hidden')
        }}/>
      </div>
      {boxAmount ? (
        <FullWidth style={{marginTop: '10px'}}>
          <FullWidth className={'flex'}>
            <SetAmount
              isOrder={isOrder}
              amount={amountValue}
              label={measurement}
            />
            <SetAmount
              isOrder={isOrder}
              name={'productBox'}
              amount={boxValue}
              label={`${boxName} (${numberFormat(boxAmount, measurement, ' ')})`}
            />
          </FullWidth>
          <FullWidth className={'flex'} style={{marginTop: '10px'}}>
            <Button
              width={'50%'}
              height={'50px'}
              style={{
                fontSize: '16px !important',
                fontWeight: '500',
                fontFamily: '"Medium", sans-serif !important'
              }}
              radius={'10px'}
              background={'#e66767'}
              onClick={() => {
                onDelete && onDelete()
                handleRemove(amount * -1)
                bottomSheet.close({id: 'detail'})
                document.querySelector('body').classList.remove('hidden')
              }}
              title={t('delete_cart')}
            />
            <Button
              width={'50%'}
              height={'50px'}
              style={{
                fontSize: '16px !important',
                fontWeight: '500',
                fontFamily: '"Medium", sans-serif !important'
              }}
              radius={'10px'}
              onClick={() => {
                const rawBox = window.productBox
                const rawAmount = window.productAmount

                const finalBox = typeof rawBox === 'number' ? rawBox : boxValue
                const finalAmount = typeof rawAmount === 'number' ? rawAmount : amountValue

                const final = toNumber(finalAmount) + toNumber(finalBox * boxAmount)

                handleChange(final)
                bottomSheet.close({ id: 'detail' })
                document.querySelector('body').classList.remove('hidden')
              }}
              title={t('add_to_cart')}
            />
          </FullWidth>
        </FullWidth>
      ) : (
        <div className={'flex'} style={{marginTop: '10px'}}>
          <SetAmount
            isOrder={isOrder}
            isDetail
            amount={amount === null || amount === 0 ? null : amount}
            width={'50%'}
          />
          <Button
            width={'50%'}
            height={'50px'}
            style={{
              fontSize: '16px !important',
              fontWeight: '500',
              fontFamily: '"Medium", sans-serif !important'
            }}
            radius={'10px'}
            onClick={() => {
              handleChange(window.productAmount === 0 ? 0 : window.productAmount || amount)
              bottomSheet.close({id: 'detail'})
              document.querySelector('body').classList.remove('hidden')
            }}
            title={t('add_to_cart')}
          />
        </div>
      )}
    </Header>
  );

  return (
    <Wrapper width={width}>
      <Image onClick={openDetail}>
        {exist ?
          <EditIcon onClick={openDetail}>
            <Edit2 stroke={'#ffffff'} size={14}/>
          </EditIcon>
          : null
        }
        <img src={image || noPhoto} alt={''}/>
      </Image>
      <Content>
        <Name onClick={openDetail}>
          <p>
            {name}
          </p>
        </Name>
        <Price>
          <p>{formatNumber(cashPrice, `${currency}`, ' ')}</p>
        </Price>
        {available && <Available>
          <p>{formatNumber(available, measurement)}</p>
        </Available>}
      </Content>
      <Fixed>
        {
          !exist ?
            <Button
              height={'35px'}
              fontSize={'14px'}
              onClick={() => handleChange(amount || 1)}
              title={t('add_to_cart')}
              radius={'8px'}
            />
            : null
        }
        {
          exist ?
            <Calc>
              <Button
                onClick={() => handleRemove()}
                title={amount === 1 ? <Trash2 stroke={'#F43F3C'} size={18}/> :<Minus stroke={'#2934D0'} size={18}/>}
                width={'40px'}
                height={'35px'}
                background={'transparent'}
              />
              <Label onClick={openDetail}>
                <p>{formatNumber(amount, measurement, ' ')}</p>
              </Label>
              <Button
                onClick={() => handleAdd()}
                title={<Plus stroke={'#2934D0'} size={18}/>}
                width={'40px'}
                height={'35px'}
                background={'transparent'}
              />
            </Calc>
            : null
        }
      </Fixed>
    </Wrapper>
  )
}

Card.propTypes = {
  width: PropTypes.string,
  data: PropTypes.object
}

export default Card
